// Thin PostHog wrapper (§C analytics). PostHog is initialised in index.html;
// this no-ops safely if it's blocked or not yet loaded.
export const track = (event, props = {}) => {
  try {
    window.posthog?.capture?.(event, props);
  } catch {
    /* analytics must never break the app */
  }
};

// Tie subsequent events to a known user so funnels are per-person, not per-device.
export const identify = (id, props = {}) => {
  try {
    if (id) window.posthog?.identify?.(id, props);
  } catch {
    /* analytics must never break the app */
  }
};
